
import { applyMiddleware, createStore, combineReducers } from "redux";
import thunk from "redux-thunk";
import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import loginReducer from "./login/loginReducer";
import matterReducer from "./components/matter/matterReducer";
import matterSearchReducer from "./components/matterSearch/matterSearchReducer";
import summaryMatterReducer from "./components/summaryMatter/summaryMatterReducer";
import summaryMilestonesReducer from "./components/summaryMilestones/summaryMilestonesReducer";
import documentsReducer from "./documents/documentsReducers";
import actionsReducer from "./components/actions/actionsReducer";
import updatesReducers from "./components/updates/updatesReducer";
import teamReducers from "./components/team/teamReducer";
import clientDataCollect from "./clientDataCollect/clientDataCollectReducer";
import actionReducer from "./components/action/actionReducer";
import dropdownValuesReducer from "./components/dropdownValues/dropdownValuesReducer";
import saveFormDataReducer from "./components/saveFormData/saveFormDataReducer";
import caseSearchReducer from "./caseSearch/caseSearchReducer"
const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["login", "matter", "action", "caseSearch"],
  stateReconciler: autoMergeLevel2
};

const rootReducer = combineReducers({
  login: loginReducer,
  matter: matterReducer,
  matterSearch: matterSearchReducer,
  summaryMatter: summaryMatterReducer,
  summaryMilestones: summaryMilestonesReducer,
  documents: documentsReducer,
  actions: actionsReducer,
  updates: updatesReducers,
  team: teamReducers,
  clientDataCollect: clientDataCollect,
  action: actionReducer,
  dropdownValues: dropdownValuesReducer,
  saveFormData: saveFormDataReducer,
  caseSearch: caseSearchReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  applyMiddleware(thunk)
);

export default store;